const BASE = '/api';

async function req(method, path, body) {
  const opts = {
    method,
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
  };
  if (body !== undefined) opts.body = JSON.stringify(body);
  const res = await fetch(BASE + path, opts);
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Request failed' }));
    const error = new Error(err.error || 'Request failed');
    error.status = res.status;
    throw error;
  }
  return res.json();
}

export const api = {
  // Auth
  authStatus: () => req('GET', '/auth/status'),
  setupAuth: (data) => req('POST', '/auth/setup', data),
  login: (data) => req('POST', '/auth/login', data),
  logout: () => req('POST', '/auth/logout'),

  // Sheep
  listSheep: (status) => req('GET', `/sheep${status ? `?status=${status}` : ''}`),
  searchSheep: (query, filters = {}) => {
    const params = new URLSearchParams();
    params.set('q', query);
    if (filters.status) params.set('status', filters.status);
    if (filters.limit) params.set('limit', filters.limit);
    return req('GET', `/sheep/search?${params.toString()}`);
  },
  getSheep: (id) => req('GET', `/sheep/${id}`),
  createSheep: (data) => req('POST', '/sheep', data),
  updateSheep: (id, data) => req('PUT', `/sheep/${id}`, data),
  deleteSheep: (id) => req('DELETE', `/sheep/${id}`),
  getLineage: (id) => req('GET', `/sheep/${id}/lineage`),
  getOffspring: (id) => req('GET', `/sheep/${id}/offspring`),

  // Stats
  getStats: () => req('GET', '/stats'),
  getMonthlyReport: (months = 12) => req('GET', `/reports/monthly?months=${months}`),
  getFlockReport: () => req('GET', '/reports/flock'),
  getAlerts: (days = 30) => req('GET', `/alerts?days=${days}`),

  // Vaccinations
  listVaccinations: (id) => req('GET', `/sheep/${id}/vaccinations`),
  addVaccination: (id, data) => req('POST', `/sheep/${id}/vaccinations`, data),
  updateVaccination: (id, data) => req('PUT', `/vaccinations/${id}`, data),
  deleteVaccination: (id) => req('DELETE', `/vaccinations/${id}`),

  // Treatments
  listTreatments: (id) => req('GET', `/sheep/${id}/treatments`),
  addTreatment: (id, data) => req('POST', `/sheep/${id}/treatments`, data),
  updateTreatment: (id, data) => req('PUT', `/treatments/${id}`, data),
  deleteTreatment: (id) => req('DELETE', `/treatments/${id}`),

  // Health events
  listHealthEvents: (id) => req('GET', `/sheep/${id}/health_events`),
  addHealthEvent: (id, data) => req('POST', `/sheep/${id}/health_events`, data),
  replaceHealthEvent: (id, data) => req('PUT', `/health_events/${id}`, data),
  updateHealthEvent: (id, data) => req('PATCH', `/health_events/${id}`, data),
  deleteHealthEvent: (id) => req('DELETE', `/health_events/${id}`),

  // Weights
  listWeights: (id) => req('GET', `/sheep/${id}/weights`),
  addWeight: (id, data) => req('POST', `/sheep/${id}/weights`, data),
  updateWeight: (id, data) => req('PUT', `/weights/${id}`, data),
  deleteWeight: (id) => req('DELETE', `/weights/${id}`),

  // Lambing
  listLambing: (id) => req('GET', `/sheep/${id}/lambing`),
  addLambing: (id, data) => req('POST', `/sheep/${id}/lambing`, data),
  updateLambing: (id, data) => req('PUT', `/lambing/${id}`, data),
  deleteLambing: (id) => req('DELETE', `/lambing/${id}`),

  // Breeding
  listBreeding: (id) => req('GET', `/sheep/${id}/breeding`),
  addBreeding: (id, data) => req('POST', `/sheep/${id}/breeding`, data),
  updateBreeding: (id, data) => req('PUT', `/breeding/${id}`, data),
  deleteBreeding: (id) => req('DELETE', `/breeding/${id}`),

  // Farm finance
  listTransactions: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.type) params.set('type', filters.type);
    if (filters.month) params.set('month', filters.month);
    const query = params.toString();
    return req('GET', `/transactions${query ? `?${query}` : ''}`);
  },
  createTransaction: (data) => req('POST', '/transactions', data),
  updateTransaction: (id, data) => req('PUT', `/transactions/${id}`, data),
  deleteTransaction: (id) => req('DELETE', `/transactions/${id}`),

  // Admin
  listBackups: () => req('GET', '/admin/backups'),
  createBackup: () => req('POST', '/admin/backups'),
  exportUrl: () => `${BASE}/admin/export`,
  exportTableUrl: (table) => `${BASE}/admin/export/${table}.csv`,
};
